import { useCallback } from 'react';

export const useCheckboxChangeHandler = (setDataPoints) =>
  useCallback(
    (index, event) => {
      const { value, checked } = event.target;
      setDataPoints((prev) =>
        prev.map((dp, i) => {
          if (i !== index) return dp;

          let updatedDataPoint = {
            ...dp,
            selectedOptions: checked
              ? [...dp.selectedOptions, value]
              : dp.selectedOptions.filter((option) => option !== value),
          };

          // Clear associated data when unchecking
          if (!checked) {
            switch (value) {
              case 'Add ABC Data':
                updatedDataPoint.abcData = {
                  antecedent: '',
                  behavior: '',
                  consequence: '',
                  setting: '',
                  notes: '',
                };
                break;
              case 'Add Phase Change Line':
                updatedDataPoint.phaseChange = '';
                break;
              case 'Add Event Line':
                updatedDataPoint.eventLine = '';
                break;
              case 'Add Preceding Behavior':
                updatedDataPoint.precedingBehavior = '';
                break;
              case 'Add Time of Collection':
                updatedDataPoint.timeOfCollection = '';
                break;
              case 'Add Setting/Location':
                updatedDataPoint.settingLocation = '';
                break;
              case 'Add Staff Present Information':
                updatedDataPoint.additionalStaff = false;
                updatedDataPoint.numberOfStaffs = 0;
                break;
              case 'Add Prompting Level':
                updatedDataPoint.promptingLevel = '';
                break;
              default:
                break;
            }
          }

          return updatedDataPoint;
        })
      );
    },
    [setDataPoints]
  );

export const useTimeChangeHandler = (setDataPoints) =>
  useCallback(
    (index, newTime) => {
      setDataPoints((prev) =>
        prev.map((dp, i) => (i === index ? { ...dp, timeOfCollection: newTime } : dp))
      );
    },
    [setDataPoints]
  );

export const useNumericFieldChangeHandler = (setDataPoints) =>
  useCallback(
    (index, field, value) => {
      if (value === '' || value === null || value === undefined) {
        setDataPoints((prev) =>
          prev.map((dp, i) => (i === index ? { ...dp, [field]: '' } : dp))
        );
      } else {
        const numericValue = parseFloat(value);
        if (!isNaN(numericValue)) {
          setDataPoints((prev) =>
            prev.map((dp, i) => (i === index ? { ...dp, [field]: numericValue } : dp))
          );
        }
      }
    },
    [setDataPoints]
  );

export const useFieldChangeHandler = (setDataPoints) =>
  useCallback(
    (index, field, newValue) => {
      setDataPoints((prev) => prev.map((dp, i) => (i === index ? { ...dp, [field]: newValue } : dp)));
    },
    [setDataPoints]
  );

export const useAbcChangeHandler = (setDataPoints) =>
  useCallback(
    (index, e) => {
      const { name, value } = e.target;
      setDataPoints((prev) =>
        prev.map((dp, i) =>
          i === index ? { ...dp, abcData: { ...dp.abcData, [name]: value } } : dp
        )
      );
    },
    [setDataPoints]
  );

export const usePromptingChangeHandler = (setDataPoints) =>
  useCallback(
    (index, field, value) => {
      if (value === '' || value === null || value === undefined) {
        setDataPoints((prev) =>
          prev.map((dp, i) =>
            i === index ? { ...dp, prompting: { ...dp.prompting, [field]: '' } } : dp
          )
        );
      } else {
        const numericValue = parseFloat(value);
        if (!isNaN(numericValue)) {
          setDataPoints((prev) =>
            prev.map((dp, i) =>
              i === index
                ? { ...dp, prompting: { ...dp.prompting, [field]: numericValue } }
                : dp
            )
          );
        }
      }
    },
    [setDataPoints]
  );

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  useCheckboxChangeHandler,
  useTimeChangeHandler,
  useNumericFieldChangeHandler,
  useFieldChangeHandler,
  useAbcChangeHandler,
  usePromptingChangeHandler,
};


